<template>
  <div>
    <menubar :permission="permission"/>
    <div id="contract" className="container">
      <div id="title" className="d-flex justify-content-start">
        <img src="/img/05_slash.svg"/>
        <p className="h1">ご契約内容</p>
      </div>
      <div className="information">
        <table className="table">
          <tbody>
            <tr>
              <th scope="col">契約者名</th>
              <td scope="col">{{ contractInformation.userCompany }}</td>
            </tr>
            <tr>
              <th scope="col">契約開始日</th>
              <td>
                {{ contractInformation.term.starts }} 〜 {{ contractInformation.term.ends }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>ご契約内容について変更をご希望の方は、メニューのお問い合わせからお願いいたします。</p>
    </div>
    <footerComponent/>
  </div>
</template>

<style lang="css" scoped>
body {
  background-color: #fffbf9;
}

#title {
  margin: 3rem 0;
}

#title img {
  width: 3rem;
  height: 3rem;
}

#title p {
  color: #666666;
  margin: 0;
}

.container {
  min-height: 80vh;
}

.information {
  border: 1px solid;
  border-radius: 10px;
  padding: 2rem 2rem;
  color: #666666;
}

table {
  color: #666666;
}

p {
  margin-top: 2rem;
  color: #666666;
}
</style>

<script>
import {defineComponent} from "vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";

export default defineComponent({
  components: {menubar, footerComponent},
  props: {
    contractInformation: {
      userCompany: String,
      course: String,
      summary: String,
      term: {
        starts: String,
        ends: String,
      },
    },
    permission:String,
  }
});
</script>
